(function() {
  // Relocates the payment methods section content to the placeholder anchor block
  function initPaymentMethods() {
    const anchor = document.querySelector('.payment-methods-anchor');
    if (!anchor) return;

    // Because Shopify Editor may inject a new HTML block in the original location 
    // while the old one is still in the anchor, we must query all elements and pick the fresh one.
    const sections = document.querySelectorAll('#pdp-payment-methods');
    let freshSection = null;

    sections.forEach(function(section) {
      if (!anchor.contains(section)) {
        freshSection = section;
      }
    });

    // Fallback to the first one if there's only one (e.g. initial load)
    if (!freshSection && sections.length > 0) {
      freshSection = sections[0];
    }

    if (freshSection) {
      // Clear previous injected nodes to prevent duplicate rendering in Editor
      anchor.innerHTML = '';
      anchor.appendChild(freshSection);
      freshSection.classList.remove('hidden');
    }
  }

  // Run immediately or on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPaymentMethods);
  } else {
    initPaymentMethods();
  }

  // Array of Shopify Theme Editor events to listen for (handles both sections and blocks)
  const shopifyEditorEvents = [
    'shopify:section:load',
    'shopify:section:select',
    'shopify:block:select',
    'shopify:block:deselect'
  ];

  // Re-run the relocation for dynamic preview updates in the editor
  shopifyEditorEvents.forEach(function(eventName) {
    document.addEventListener(eventName, function(event) {
      // Check if the event corresponds to our specific section ID or if the target block is inside our section
      if (
        event.detail.sectionId === 'pdp-payment-methods' || 
        (event.target && event.target.closest('#pdp-payment-methods'))
      ) {
        // Add a small timeout to allow Shopify's DOM manipulation to finish before moving the node
        setTimeout(initPaymentMethods, 50);
      }
    });
  });
})();
